import React from 'react';
import './LoadingSpinner.css';

//Code from: https://icons8.com/cssload/en/spinners
export default function LoadingSpinner(props){
    return (
        <div>
            <div className="loading-spinner__message">
                {props.message}
            </div>
            <div id="floatingCirclesG">
                <div className="f_circleG" id="frotateG_01"></div>
                <div className="f_circleG" id="frotateG_02"></div>
                <div className="f_circleG" id="frotateG_03"></div>
                <div className="f_circleG" id="frotateG_04"></div>
                <div className="f_circleG" id="frotateG_05"></div>
                <div className="f_circleG" id="frotateG_06"></div>
                <div className="f_circleG" id="frotateG_07"></div>
                <div className="f_circleG" id="frotateG_08"></div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/common/LoadingSpinner.js